/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {


	var $win = jQuery(window),
		$body = jQuery('body');


	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});
	jQuery(window).on('load', function() {

		if ( jQuery('#main-nav .merch-link') ) {
			var merch_link = jQuery('#main-nav .merch-link a').attr("href");
			jQuery('.section-products .more-link a').attr("href", merch_link).attr("target", "_blank");
		} else {
			jQuery('.section-products .more-link a').hide();
		}

		jQuery('.js-subscribe a').on('click', function(e) {
			e.preventDefault();

			// var $target = jQuery(this).attr('href');

			// jQuery('html, body').animate({
			// 	scrollTop: jQuery($target).offset().top
			// }, 800);

			if ( jQuery(this).parents('.off-canvas') ) {
				jQuery('.js-off-canvas-overlay').trigger('click');
			}
			jQuery('.ae-cform-modal-display-cta').trigger('click');
		});

		if( $body.hasClass('home') ) {

			setTimeout(function(){ 
				jQuery('.ae-cform-modal-display-cta').trigger('click');
			}, 15000);

			jQuery("section.section").each(function(index) {
				var controller2 = new ScrollMagic.Controller();
				var currentEl2 = this;
	  
				var blockScene = new ScrollMagic.Scene({
					triggerElement: currentEl2,
					offset: 0,
					triggerHook: .6,
					reverse: false
				})
				.setClassToggle(currentEl2, 'animate-in')
				.addTo(controller2)
			});



			var $banner = jQuery('.js-banner'),
				$videos = jQuery('.js-video-list');
			
			$banner.slick({
				dots: false,
				fade: true,
				cssEase: 'linear',
				responsive: [
				  {
					breakpoint: 815,
					settings: {
						arrows: false
					}
				  }
				]
			});

            $banner.on('beforeChange', function(event, slick, currentSlide, nextSlide){
              $banner.addClass('is-sliding');
            });
      
            $banner.on('afterChange', function(event, slick, currentSlide){
              $banner.removeClass('is-sliding');
            });

			jQuery('.js-news-list').slick({
				slidesToShow: 2,
				slidesToScroll: 1,
				responsive: [
				  {
					breakpoint: 600,
					settings: {
					  slidesToShow: 1,
					  slidesToScroll: 1
					}
				  }
				]
			});


			// jQuery('.js-products-list').slick({
			// 	slidesToShow: 3,
			// 	slidesToScroll: 1,
			// 	responsive: [
			// 	  {
			// 		breakpoint: 600,
			// 		settings: {
			// 		  slidesToShow: 1,
			// 		  slidesToScroll: 1
			// 		}
			// 	  }
			// 	]
			// });

			jQuery('.js-release-list').slick({
				dots: false
			});

			$videos.slick({
				dots: false,
				fade: true,
				cssEase: 'linear',
				// responsive: [
				//   {
				// 	breakpoint: 815,
				// 	settings: {
				// 		arrows: false
				// 	}
				//   }
				// ]
			});

            $videos.on('beforeChange', function(event, slick, currentSlide, nextSlide){
			  $videos.addClass('is-sliding');
			  jQuery('.media-youtube-video').remove();
				jQuery('.article-video').removeClass('playing');
				jQuery('.article-header').removeClass('playing');
            });
      
            $videos.on('afterChange', function(event, slick, currentSlide){
			  $videos.removeClass('is-sliding');
			  jQuery('.media-youtube-video').remove();
				jQuery('.article-video').removeClass('playing');
				jQuery('.article-header').removeClass('playing');
            });

			jQuery('.article-video .button').on('click', function(e) {
				e.preventDefault();
		
				var youtubeID = jQuery(this).data('id'),
					embedCode = "<div class='media-youtube-video'><iframe src='https://www.youtube.com/embed/" + youtubeID + "?showinfo=0&autohide=1&rel=0&autoplay=1&wmode=transparent' frameborder='0' allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe></div>",
					$parent = jQuery(this).parent().parent().parent().parent();
					
				if (!document.querySelector('.media-youtube-video')) {
				$parent.addClass('playing');
				$parent.append(embedCode);
				} else {
				$parent.removeClass('playing');
				jQuery('.media-youtube-video').remove();
				}
			});
			jQuery('.js-video-list button').on('click', function(){
			if (jQuery('.article-video .article-header').hasClass('playing')) {
				jQuery('.media-youtube-video').remove();
				jQuery('.article-video').removeClass('playing');
				jQuery('.article-header').removeClass('playing');
			}
			});
		}

		jQuery('.js-video-page').slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			responsive: [
			{
				breakpoint: 600,
				settings: {
				slidesToShow: 1,
				slidesToScroll: 1
				}
			}
			]
		});

		jQuery('.js-music-page').slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			responsive: [
			{
				breakpoint: 600,
				settings: {
				slidesToShow: 1,
				slidesToScroll: 1
				}
			}
			]
		});

		// wrap span on word break
		// jQuery(window).resize(function() {
		// 	letterStack();
		// });

		// letterStack();

		function letterStack() {
			jQuery('.banner-item').each(function(index){
				var btWt = jQuery(this).find('.content'),
					bTitle = jQuery(this).find('h2');
	
				var spanInserted = bTitle.html().split(" ").join(" </span><span>");
				var wrapped = ("<span>").concat(spanInserted, "</span>");
				bTitle.html(wrapped);
				var refPos = jQuery(this).find('span:first-child').position().top;
				var newPos;
	
				jQuery(this).find('span').each(function(index) {
					newPos = jQuery(this).position().top   
					if (index == 0){
					   return;
					}
					if (newPos == refPos){
						jQuery(this).prepend(jQuery(this).prev().text() + " ");
						jQuery(this).prev().remove();
					} 
					refPos = newPos;
				});
			});
		}
	});
}); 